import React from "react"
import PropTypes from "prop-types"
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share"

import "./ShareIcons.scss"

const ShareIcons = ({ shareUrl }) => {
  return (
    <div className="share-icons">
      <span className="share-icon-label">SHARE</span>
      <FacebookShareButton url={shareUrl}>
        <span className="icon-wrap icon-facebook">
          <FacebookIcon size={48} iconFillColor="black" bgStyle={{ fill: "transparent" }} />
        </span>
      </FacebookShareButton>
      <LinkedinShareButton url={shareUrl}>
        <span className="icon-wrap icon-linkedin">
          <LinkedinIcon size={48} iconFillColor="black" bgStyle={{ fill: "transparent" }} />
        </span>
      </LinkedinShareButton>
      <TwitterShareButton url={shareUrl}>
        <span className="icon-wrap icon-twitter">
          <TwitterIcon size={48} iconFillColor="black" bgStyle={{ fill: "transparent" }} />
        </span>
      </TwitterShareButton>
      <WhatsappShareButton url={shareUrl}>
        <span className="icon-wrap icon-whatsapp">
          <WhatsappIcon size={38} iconFillColor="black" bgStyle={{ fill: "transparent" }} />
        </span>
      </WhatsappShareButton>
    </div>
  )
}

ShareIcons.propTypes = {
  shareUrl: PropTypes.string,
}

export default ShareIcons
